function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { memo } from 'react';
import styles from './DefaultPlaceholder.module.scss';
import cs from 'classnames';
import Style from '../../Style';
function generateRandomInteger(min, max) {
  return Math.floor(min + Math.random() * (max + 1 - min));
}
function getBaseFontSize() {
  if (window && document.head) {
    return parseFloat(window.getComputedStyle(document.head).fontSize || '16');
  } else {
    return 16;
  }
}
var BASE_BG_IMAGE = ["linear-gradient(\n\t90deg,\n\thsla(0, 0%, 100%, 0),\n\thsla(0, 0%, 100%, 0.5) 50%,\n\thsla(0, 0%, 100%, 0) 80%\n)"];
var BASE_BG_SIZE = ["15% 100%"];
var BASE_BG_POSITION = ['0 0'];
var ANIMATED_BG_POSITION = ['100% 0'];
var DEFAULT_OFFSET = [0, 0];
var DEFAULT_LENGTH = [40, 80];
function DefaultPlaceholder(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 26 : _ref$height,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 1.5 : _ref$spacing,
    id = _ref.id,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? DEFAULT_OFFSET : _ref$offset,
    _ref$length = _ref.length,
    length = _ref$length === void 0 ? DEFAULT_LENGTH : _ref$length,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 5 : _ref$rows;
  var heightBase = height / getBaseFontSize();
  var remHeight = "".concat(heightBase, "rem");
  var uniqueId = "".concat(id, "-").concat(rows);
  var className = "".concat(uniqueId, "-row");
  var widths = Array.from(Array(rows)).map(function () {
    return [generateRandomInteger.apply(void 0, _toConsumableArray(offset)), generateRandomInteger.apply(void 0, _toConsumableArray(length))];
  });
  var backgroundImage = BASE_BG_IMAGE.concat(widths.map(function () {
    return "linear-gradient(hsl(0, 0%, 80%) ".concat(remHeight, ", transparent 0)");
  })).join(',');
  var backgroundSize = BASE_BG_SIZE.concat(widths.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      width = _ref3[1];
    return "".concat(width, "% ").concat(remHeight);
  })).join(',');
  var backgroundPosition = widths.map(function (_ref4, i) {
    var _ref5 = _slicedToArray(_ref4, 1),
      offset = _ref5[0];
    return i ? "".concat(offset, "rem ").concat(heightBase * i * spacing, "rem") : '0 0';
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Style, {
    id: uniqueId
  }, "\n\t\t\t.".concat(className, " {\n\t\t\t\theight: ").concat(rows * heightBase * spacing + spacing, "rem;\n\t\t\t\tanimation: ").concat(className, "-shine 2s infinite;\n\t\t\t\tbackground-image: ").concat(backgroundImage, ";\n\t\t\t\tbackground-size: ").concat(backgroundSize, ";\n\t\t\t\tbackground-position: ").concat(BASE_BG_POSITION.concat(backgroundPosition).join(','), ";\n\t\t\t}\n\t\t\t@keyframes ").concat(className, "-shine {\n\t\t\t\tto {\n\t\t\t\t\tbackground-position: ").concat(ANIMATED_BG_POSITION.concat(backgroundPosition).join(','), ";\n\t\t\t\t}\n\t\t\t}")), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.row, className)
  }));
}
export default memo(DefaultPlaceholder);